/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1FeedbackId202,
  DeleteApiV1FeedbackId401,
  DeleteApiV1FeedbackId404,
  DeleteApiV1FeedbackId500,
  DeleteApiV1FeedbackIdMutationResponse,
  DeleteApiV1FeedbackIdPathParams,
} from "../../types/feedbackRegistroController/DeleteApiV1FeedbackId.ts";

export const deleteApiV1FeedbackIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1FeedbackIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1FeedbackId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1FeedbackId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1FeedbackId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1FeedbackId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackId500>;

export const deleteApiV1FeedbackIdMutationResponseSchema = z.lazy(
  () => deleteApiV1FeedbackId202Schema,
) as unknown as ToZod<DeleteApiV1FeedbackIdMutationResponse>;
